import {
  LOAD_SERVICE_FAVORITE_STATUS,
  LOAD_SERVICE_FAVORITE_STATUS_SUCCESS,
  CHANGE_SERVICE_FAVORITE_STATUS,
  CHANGE_SERVICE_FAVORITE_STATUS_SUCCESS
} from '../constants';

export const loadServiceFavouriteStatus = () => ({
  type: LOAD_SERVICE_FAVORITE_STATUS,
  payload: []
});

export const loadServiceFavoriteStatusSuccess = payload => ({
  type: LOAD_SERVICE_FAVORITE_STATUS_SUCCESS,
  payload
});

export const changeServiceFavoriteStatus = () => ({
  type: CHANGE_SERVICE_FAVORITE_STATUS,
  payload: []
});

export const changeServiceFavoriteStatusSuccess = payload => ({
  type: CHANGE_SERVICE_FAVORITE_STATUS_SUCCESS,
  payload
});
